var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar",
    d: "M4.625-5H3.375A.331.331,0,0,1,3-5.375v-1.25A.331.331,0,0,1,3.375-7h1.25A.331.331,0,0,1,5-6.625v1.25A.331.331,0,0,1,4.625-5ZM8-5.375A.331.331,0,0,1,7.625-5H6.375A.331.331,0,0,1,6-5.375v-1.25A.331.331,0,0,1,6.375-7h1.25A.331.331,0,0,1,8-6.625Zm3,0A.331.331,0,0,1,10.625-5H9.375A.331.331,0,0,1,9-5.375v-1.25A.331.331,0,0,1,9.375-7h1.25A.331.331,0,0,1,11-6.625Zm-3,3A.331.331,0,0,1,7.625-2H6.375A.331.331,0,0,1,6-2.375v-1.25A.331.331,0,0,1,6.375-4h1.25A.331.331,0,0,1,8-3.625Zm-3,0A.331.331,0,0,1,4.625-2H3.375A.331.331,0,0,1,3-2.375v-1.25A.331.331,0,0,1,3.375-4h1.25A.331.331,0,0,1,5-3.625Zm6,0A.331.331,0,0,1,10.625-2H9.375A.331.331,0,0,1,9-2.375v-1.25A.331.331,0,0,1,9.375-4h1.25A.331.331,0,0,1,11-3.625ZM14-10.5V.5a1.447,1.447,0,0,1-.437,1.063A1.447,1.447,0,0,1,12.5,2H1.5A1.447,1.447,0,0,1,.438,1.563,1.447,1.447,0,0,1,0,.5v-11a1.447,1.447,0,0,1,.438-1.062A1.447,1.447,0,0,1,1.5-12H3v-1.625A.331.331,0,0,1,3.375-14h1.25A.331.331,0,0,1,5-13.625V-12H9v-1.625A.331.331,0,0,1,9.375-14h1.25a.331.331,0,0,1,.375.375V-12h1.5a1.447,1.447,0,0,1,1.063.438A1.447,1.447,0,0,1,14-10.5ZM12.5.313V-9H1.5V.313A.166.166,0,0,0,1.688.5H12.313A.166.166,0,0,0,12.5.313Z",
    transform: "translate(0 14)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.eb3bf24215d0814fdd4687bf8df2d682.svg";
export { ForwardRef as ReactComponent };